import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot, UrlTree, Router } from '@angular/router';
import { Observable } from 'rxjs';
import { ConfigService } from '../services/config.service';
import { LogglyService } from 'src/app/services/loggly.service';
import { SubscriptionsService } from '../services/subscriptions.service';

@Injectable({
  providedIn: 'root'
})
export class AuthGuardGuard  {
  constructor(private router: Router, private configService: ConfigService, private logglyService: LogglyService, private subscriptionsService: SubscriptionsService) {

  }
  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
    let loginDetails = JSON.parse(localStorage.getItem('admin_Details') ?? 'null');
    let subscriptionDetails = JSON.parse(localStorage.getItem('SubscriptionFeatures') ?? 'null');
    this.subscriptionsService.subscriptionFeatures$.subscribe((features: any) => {
      if (features) {
        subscriptionDetails = features;
      }
    });
    const fullUrl = state.url;
    
    // Not logged in
    if (!loginDetails?.UserID) {
       this.logglyService.log('AuthGuard - loginDetails missing, redirecting to login page.');
       this.configService.sessionLogout();
      return false;
    }
    // If route has a requiredRole (superadmin) in its data, check it
    const requiredRole = route.data['requiredRole'];
    if (requiredRole && loginDetails.UserType !== requiredRole) {
      this.router.navigate(['/dashboard/summary']);
      return false;
    }

    // SUBSCRIPTION FEATURES CHECK
    if(fullUrl.includes('/dashboard/summary')){
      if(subscriptionDetails?.dashboard?.show && !subscriptionDetails?.dashboard?.disable){
        return true;
      }else{
        return false;
      }
    }
    if(fullUrl.includes('/sales/pos')){
      if(subscriptionDetails?.pos?.show && !subscriptionDetails?.pos?.disable){
        return true;
      }else{
        return false;
      }
    }
    if(fullUrl.includes('/secondhand')){
      if(subscriptionDetails?.secondhand?.show && !subscriptionDetails?.secondhand?.disable){
        return true;
      }else{
        return false;
      }
    }
    // if(fullUrl.includes('/reports')){
    //   if(subscriptionDetails?.reports?.show && !subscriptionDetails?.reports?.disable){
    //     return true;
    //   }else{
    //     return false;
    //   }
    // }
    if(fullUrl.includes('/profile/WebsiteContent') || fullUrl.includes('/profile/SEOSettings')){
      if(subscriptionDetails?.website?.show && !subscriptionDetails?.website?.disable){
        return true;
      }else{
        return false;
      }
    }
    if(fullUrl.includes('/profile/Store-settings') || fullUrl.includes('/admin/wishlist') || fullUrl.includes('/products/Highlighted') || fullUrl.includes('products/ReviewList') ){
      if((subscriptionDetails?.store?.show && !subscriptionDetails?.store?.disable) || (subscriptionDetails?.ecomcatalog?.show && !subscriptionDetails?.ecomcatalog?.disable)){
        return true;
      }else{
        return false;
      }
    }
    if(fullUrl.includes('/profile/dvcard')){
      if(subscriptionDetails?.dvcard?.show && !subscriptionDetails?.dvcard?.disable){
        return true;
      }else{
        return false;
      }
    }
    if(fullUrl.includes('/profile/menucard')){
      if(subscriptionDetails?.restaurantmenu?.show && !subscriptionDetails?.restaurantmenu?.disable){
        return true;
      }else{
        return false;
      }
    }
    if(fullUrl.includes('/loyalty')){
      if((subscriptionDetails?.loyaltypoint?.show && !subscriptionDetails?.loyaltypoint?.disable) || (subscriptionDetails?.loyaltypointadvance?.show && !subscriptionDetails?.loyaltypointadvance?.disable)){
        return true;
      }else{
        return false;
      }
    }

    if(fullUrl.includes('/user/add') || fullUrl.includes('/user/list')){
      if(subscriptionDetails?.user?.show && !subscriptionDetails?.user?.disable){
        return true;
      }else{
        return false;
      }
    }
    if(fullUrl.includes('/user/customer-add/user') || fullUrl.includes('/user/customer-add/shop')){
      if(subscriptionDetails?.customer?.show && !subscriptionDetails?.customer?.disable){
        return true;
      }else{
        return false;
      }
    }
    if(fullUrl.includes('/vendor') || fullUrl.includes('/purchases')){
      if(subscriptionDetails?.vendor?.show && !subscriptionDetails?.vendor?.disable){
        return true;
      }else{
        return false;
      }
    }

    return true;
  }

}
